import { render, staticRenderFns } from "./BusinessDetailsForm.vue?vue&type=template&id=41cb3957"
import script from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"
export * from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports